import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from '../../services/apiUrls';

import { toastError, toastSuccess } from "../../utils/react-toaster";
import { deleteItemScheduleData, getAllItemSchedulesData, saveAllItemSchedulesData, saveItemScheduleData } from "../slices";

export interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string,
  success?: boolean
  code?: any;
  results?: any;
  productvo?: any;
}


function* fetchAllItemSchedulesData(actions?: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.ITEM_SCHEDULES.getAllItemSchedulesApi
    })
    if (response) {
      yield put(saveAllItemSchedulesData({response}));
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteItemSchedule(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.ITEM_SCHEDULES.deleteItemScheduleApi(actions.payload.mid),
    })
    if (response.code) {
      toastError(response.code);
      actions.payload.callback && actions.payload.callback(false);
    } else {
      actions.payload.callback && actions.payload.callback(true);
    }
  } catch (error) {
    actions.payload.callback && actions.payload.callback(false);
    console.log(error);
  }
}

function* saveItemSchedule(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ITEM_SCHEDULES.saveItemScheduleApi,
      data: actions.payload.dataToPost
    })
    if (!response?.code) {
      actions.payload.callback(response);
    }
  } catch (error) {
    // actions.payload.callback(false);
    console.log(error);
  }
}



export default function* root() {
  yield takeEvery(saveItemScheduleData.type, saveItemSchedule);
  yield takeEvery(getAllItemSchedulesData.type, fetchAllItemSchedulesData);
  yield takeEvery(deleteItemScheduleData.type, deleteItemSchedule);
}

